import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { injectUntilDestroyed } from '@recruitee/utils';

import { ButtonComponent } from '../../../../common/button/components/button/button.component';
import { ButtonDropdownIndicatorDirective } from '../../../../common/button/directives/button-dropdown/button-dropdown-indicator.directive';
import { IconComponent } from '../../../../common/icon/icon.component';
import { IconName } from '../../../../icons-container/icons.type';
import { SelectController } from '../../services/select-controller.service';

@Component({
  selector: 'rt-select-trigger-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonComponent, ButtonDropdownIndicatorDirective, IconComponent],
  template: `
    <rt-button
      [variant]="buttonVariant"
      [dropdownOpened]="selectCtrl.isOpen()"
      [dropdownVisible]="dropdownIconVisible"
      (click)="selectCtrl.toggle(true)"
    >
      @if (icon; as iconName) {
        <rt-icon [name]="iconName" />
      }
      {{ selectCtrl.itemSelector.selected()?.label || label }}
    </rt-button>
  `,
})
export class Select2TriggerButtonComponent {
  @Input() public buttonVariant: ButtonComponent['variant'] = 'plain';
  @Input() public label: string | null = null;
  @Input() public icon: IconName | null = null;
  @Input() public dropdownIconVisible = true;

  private untilDestroyed = injectUntilDestroyed();

  constructor(
    public selectCtrl: SelectController,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    this.selectCtrl.detectChanges$
      .pipe(this.untilDestroyed)
      .subscribe(() => this.cdRef.detectChanges());
  }
}
